const AlertPrimary = (props: React.HTMLAttributes<SVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect width="24" height="24" rx="12" fill="#00355E" />
    <path
      d="M11.3251 14.7628L11.1451 5.65479H12.7831L12.6031 14.7628H11.3251ZM12.0091 18.3448C11.7091 18.3448 11.4571 18.2488 11.2531 18.0568C11.0611 17.8528 10.9651 17.6068 10.9651 17.3188C10.9651 17.0308 11.0611 16.7908 11.2531 16.5988C11.4571 16.3948 11.7091 16.2928 12.0091 16.2928C12.2971 16.2928 12.5371 16.3948 12.7291 16.5988C12.9331 16.7908 13.0351 17.0308 13.0351 17.3188C13.0351 17.6068 12.9331 17.8528 12.7291 18.0568C12.5371 18.2488 12.2971 18.3448 12.0091 18.3448Z"
      fill="white"
    />
  </svg>
);
export default AlertPrimary;
